import './Banner.css'

function Banner () {
    return (
        <header className='banner'>
            <img src="/imagens/banner.png" alt="Banner principal da página Organo"/>
        </header>
    )
}

export default Banner